import { render, staticRenderFns } from "./br-hero.vue?vue&type=template&id=981a2bc0"
import script from "./br-hero.vue?vue&type=script&lang=js"
export * from "./br-hero.vue?vue&type=script&lang=js"
import style0 from "./br-hero.vue?vue&type=style&index=0&id=981a2bc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports